import { render, staticRenderFns } from "./AppReferral.vue?vue&type=template&id=347e3f4a&"
import script from "./AppReferral.vue?vue&type=script&lang=ts&"
export * from "./AppReferral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports